module.exports = __webpack_public_path__ + "static/media/money-bill-solid.f6285cfd.svg";